import { render } from "./OrgModal.vue?vue&type=template&id=000733e7&scoped=true"
import script from "./OrgModal.vue?vue&type=script&lang=js"
export * from "./OrgModal.vue?vue&type=script&lang=js"

import "./OrgModal.vue?vue&type=style&index=0&id=000733e7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-000733e7"

export default script